import { GET_MODEL_LIST } from "../url_helper";
import { post } from "../api_helper";

export const getModelList = data => post(GET_MODEL_LIST, data);